const CyberScreen = () => {

    return(
        <p>Cyber Screen</p>
    )
}

export default CyberScreen